/* eslint-disable  */
//@ts-nocheck

import * as React from 'react';
import auth from '@client/components/auth';
import { useGetAllProgramsQuery } from '../../../../generated/graphql';
import { browserHistory } from 'react-router';
import { ProgramPage } from './components/ProgramPage';
import { WorkoutsPage } from './components/WorkoutsPage';

export function PublishedWorkoutsPage(props) {
  const influencerId = Number(
    props.params.influencerId
      ? props.params.influencerId
      : auth.getUser().influencerId,
  );

  const url = new URL(window.location.href);
  const shouldRefresh = url.searchParams.get('refresh');

  const {
    loading: isLoading,
    data,
    refetch,
    updateQuery,
  } = useGetAllProgramsQuery({
    variables: { id: influencerId },
    skip: !influencerId,
    fetchPolicy: shouldRefresh ? 'network-only' : 'cache-first',
    onCompleted: () => {
      if (shouldRefresh) {
        url.searchParams.delete('refresh');
        browserHistory.replace(url.href);
      }
    },
  });

  const doesNotHaveData = !data?.creator;

  const programs = doesNotHaveData ? [] : data.creator.programs;

  return (
    <WorkoutsPage
      isLoading={isLoading}
      creator={data ? data.creator : { id: influencerId }}
    >
      <ProgramPage
        tab="published"
        refreshWorkouts={refetch}
        influencerId={influencerId}
        influencer={data ? data.creator : {}}
        programs={programs}
        updateQuery={updateQuery}
        {...props}
      />
    </WorkoutsPage>
  );
}
